module.exports = __webpack_public_path__ + "img/userLifecycle-rule.75abf555.png";